import { render } from "./LajnaExcecutiveList.vue?vue&type=template&id=dccc8da2&scoped=true"
import script from "./LajnaExcecutiveList.vue?vue&type=script&lang=js"
export * from "./LajnaExcecutiveList.vue?vue&type=script&lang=js"

import "./LajnaExcecutiveList.vue?vue&type=style&index=0&id=dccc8da2&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dccc8da2"]])

export default __exports__